/**
 * Lazy-loaded image fade-in animation
 * Handles fade-in animations for images with data-lazy-fade="true" attribute
 */

export function lazyImageFade() {
    // Find all images with the lazy-fade data attribute
    const lazyImages = document.querySelectorAll('img[data-lazy-fade="true"]');
    
    if (lazyImages.length === 0) return;

    //console.log('Lazy images found:', lazyImages.length);

    // Function to handle image fade-in
    const fadeInImage = (img) => {
        // Check if style is on the img itself or its parent (picture element)
        const targetElement = img.hasAttribute('data-lazy-fade') ? img : img.parentElement;
        
        //console.log('Fading in element:', targetElement, 'style before:', targetElement.style.opacity);
        
        // Set opacity to 1 to trigger the CSS transition
        targetElement.style.opacity = '1';
        
        //console.log('style after:', targetElement.style.opacity);
        
        // Optional: Remove the data attribute after processing
        img.removeAttribute('data-lazy-fade');
    };

    // Process each lazy image
    lazyImages.forEach((img, index) => {
        //console.log(`Processing image ${index}:`, img, 'complete:', img.complete, 'naturalHeight:', img.naturalHeight, 'loading:', img.loading);
        
        // Always add event listeners first, then check if already loaded
        const handleLoad = () => {
            //console.log(`Image ${index} loaded successfully`);
            fadeInImage(img);
        };

        const handleError = () => {
            //console.log(`Image ${index} failed to load`);
            // Still fade in broken images to avoid them staying hidden
            fadeInImage(img);
        };

        img.addEventListener('load', handleLoad, { once: true });
        img.addEventListener('error', handleError, { once: true });

        // Check if image is already loaded (after adding listeners)
        if (img.complete && img.naturalHeight !== 0) {
            //console.log(`Image ${index} already loaded, fading in immediately`);
            fadeInImage(img);
        } else {
            //console.log(`Image ${index} not yet loaded, waiting for load event`);
        }
    });

    // Fallback timer: force fade-in after 3 seconds for any remaining images
    setTimeout(() => {
        const remainingImages = document.querySelectorAll('img[data-lazy-fade="true"]');
        if (remainingImages.length > 0) {
            //console.log('Fallback: Forcing fade-in for remaining images:', remainingImages.length);
            remainingImages.forEach(img => fadeInImage(img));
        }
    }, 3000);

    // Re-check periodically for new lazy-loaded images
    const recheckInterval = setInterval(() => {
        const newImages = document.querySelectorAll('img[data-lazy-fade="true"]');
        if (newImages.length === 0) {
            clearInterval(recheckInterval);
            return;
        }
        
        newImages.forEach((img, index) => {
            if (img.complete && img.naturalHeight !== 0) {
                //console.log(`Re-check: Image ${index} now loaded, fading in`);
                fadeInImage(img);
            }
        });
    }, 500);

    // Stop re-checking after 10 seconds
    setTimeout(() => clearInterval(recheckInterval), 10000);
}
